import React, { Component } from 'react';
import {
  Button,
} from 'react-bootstrap';

// app history
import appHistory from '../../history';
// stores
import UserStore from '../../stores/UserStore';
// models
import UserCredential from '../../models/UserCredential';
// components
import LoginDialog from '../../components/Auth/LoginDialog';

class DeleteAccountButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialog: false,
      errorMessage: "",
    };
  }

  render() {
    let userCredential = new UserCredential({
      email: UserStore.user.email
    });

    return (
      <Button bsStyle="danger" onClick={() => this.showDialog(true)}>
        <div className="Buttons-container">
          <div className="Buttons-text">Delete account</div>
        </div>
        <LoginDialog
          show={this.state.showDialog}
          errorMessage={this.state.errorMessage}
          hideEmailField={true}
          userCredential={userCredential}
          title="Delete account"
          message={this.renderWarningText()}
          confirmButtonStyle="danger"
          confirmButtonText="Delete everything"
          onLogin={this.reauthenticateUserForDelete}
          onCancel={() => this.showDialog(false)} />
      </Button>
    );
  }

  renderWarningText = () => {
    return (
      <div style={{margin: "15px 0px"}}>
        <b style={{color: "#d9534f"}}>WARNING! This action is irreversible.</b><br /><br/>
        <div>
          <div>All of your personal and payment information will be deleted from the service. </div>
          <div>Please type in your password below to confirm.</div>
        </div>
      </div>
    );
  }

  showDialog = (bShow = false) => {
    this.setState({
      showDialog: bShow,
      errorMessage: ""
    });
  }

  reauthenticateUserForDelete = (email, password) => {
    this.setState({ errorMessage: "" });
    UserStore
    .reauthenticate(password)
    .then(UserStore.delete)
    .then(() => appHistory.push("/auth"))
    .catch(err => {
      this.setState({ errorMessage: err.message });
    });
  }
}

export default DeleteAccountButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/DeleteAccount.js